import $ from 'jquery'

const copyToClipboard = (isPrint, isGraphic) => {
  let text = $('#new-style-number' + (isPrint ? '-print' : '') + (isGraphic ? '-graphic' : '')).text().trim()
  window.prompt("Press: Control + C", text)
}

export {copyToClipboard}
